import { render, staticRenderFns } from "./EditarPost.vue?vue&type=template&id=12343e46&"
import script from "./EditarPost.vue?vue&type=script&lang=js&"
export * from "./EditarPost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports